
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/figma-imports",
      function () {
        return require("private-next-pages/figma-imports.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/figma-imports"])
      });
    }
  